<div class="pr-landing">

  <app-pr-acfs
    [showSort]="true"
    [(searchQuery)]="searchQuery"
    (search)="onSearch()"
    [sortModes]="sortModes"
    [sortBy]="sortBy"
    (sortModeChange)="onSortMode($event)">
  </app-pr-acfs>

  <div class="stats-strip" #statsStrip>
    <div class="stats-inner">
      <div class="stat-cell">
        <div class="stat-label">มาตรฐานสินค้าเกษตรที่รับรอง</div>
        <div class="stat-value-row">
          <span class="stat-value stat-value--gradient">{{ displayStandardCount }}</span>
          <span class="stat-unit">มาตรฐาน</span>
        </div>
      </div>
      <div class="stat-cell">
        <div class="stat-label">เพจประชาสัมพันธ์</div>
        <div class="stat-value-row">
          <span class="stat-value stat-value--gradient">{{ collectionSize || 0 }}</span>
          <span class="stat-unit">เพจ</span>
<!--          @if (collectionSize > 0) {-->
<!--            <span class="stat-delta">+{{ collectionSize }}</span>-->
<!--          }-->
        </div>
      </div>
      <div class="stat-cell">
        <div class="stat-label">จำนวนธุรกิจ</div>
        <div class="stat-value-row">
          <span class="stat-value stat-value--gradient">{{ displayBusinessCount }}</span>
          <span class="stat-unit">ธุรกิจ</span>
        </div>
      </div>
      <div class="stat-cell">
        <div class="stat-label">อัปเดตล่าสุด</div>
        <div class="stat-value-row">
          <span class="stat-value stat-value--date">{{ formatThaiDateShort(pages[0]?.modifiedDate ?? pages[0]?.createdDate) }}</span>
        </div>
      </div>
    </div>
  </div>

  @if (featured) {
    <section class="featured-section">
      <div class="featured-inner">
        <div class="featured-card">
          <div class="featured-media">
            @if (featured.coverPath) {
              <img [src]="featured.coverPath" [alt]="featured.pageName || 'cover'" class="featured-img">
            } @else {
              <div class="featured-placeholder">
                <svg class="featured-placeholder-glyph" width="140" height="140" viewBox="0 0 140 140" fill="none">
                  <circle cx="70" cy="70" r="64" stroke="rgba(255,255,255,0.3)" stroke-width="3" stroke-dasharray="12 6"/>
                  <circle cx="70" cy="70" r="46" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
                  <text x="70" y="84" text-anchor="middle" font-family="'Noto Serif Thai', serif" font-size="48" font-weight="700" fill="rgba(255,255,255,0.4)">Q</text>
                </svg>
                <span class="featured-placeholder-label">ใส่ภาพหลักของบทความ</span>
                <span class="featured-placeholder-hint">5:3 ratio · ขนาดแนะนำ 1600×960</span>
              </div>
            }
            <div class="featured-tag">
              <span class="featured-tag-dot"></span>
              ล่าสุด
            </div>
          </div>

          <div class="featured-body">
            <div class="featured-meta">
              <span class="featured-org">{{ getFallbackSubtitle(featured) }}</span>
              <span class="featured-sep">·</span>
              <span class="featured-date">{{ formatThaiDate(featured.modifiedDate ?? featured.createdDate) }}</span>
            </div>
            <h2 class="featured-headline">{{ featured.pageName || '-' }}</h2>
<!--            <p class="featured-deck">{{ featured.productName || 'ข้อมูลสินค้าเกษตรและอาหารที่ผ่านการรับรองมาตรฐานคุณภาพ' }}</p>-->
            @if (getProductDetailPreview(featured)) {
              <p class="featured-product-detail">{{ getProductDetailPreview(featured) }}</p>
            }

            <div class="featured-topics">
              @for (code of (featured.certificationCodes ?? []).slice(0, 5); track code) {
                <span class="topic-pill">
                  <span class="topic-dot"></span>
                  {{ code }}
                </span>
              }
              @if (!(featured.certificationCodes?.length)) {
                <span class="topic-pill"><span class="topic-dot"></span>มาตรฐาน</span>
                <span class="topic-pill"><span class="topic-dot"></span>เกษตรอินทรีย์</span>
              }
            </div>

            <div class="featured-cta-row">
              <a class="btn-primary" [routerLink]="getPageLink(featured)">
                อ่านเพิ่มเติม
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="2" y1="8" x2="13" y2="8"/><polyline points="9,4 13,8 9,12"/></svg>
              </a>
              <span class="featured-rating">
                <svg width="16" height="16" viewBox="0 0 12 12" fill="currentColor"><polygon points="6,1 7.5,4.5 11,4.8 8.5,7 9.3,10.5 6,8.5 2.7,10.5 3.5,7 1,4.8 4.5,4.5"/></svg>
                {{ (featured.averageScore || 0).toFixed(1) }}
              </span>
<!--              <span class="featured-ref">-->
<!--                ที่ มกอช. 2569/{{ featured.pageCode || '0001' }}-->
<!--                <span class="featured-sep">·</span>-->
<!--                <span class="featured-readtime">อ่าน 3 นาที</span>-->
<!--              </span>-->
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  <div class="category-nav">
    <div class="category-nav-inner">
      <div class="category-nav-box">
        <span class="category-label">หมวดหมู่</span>
        <div class="category-chips-scroll">
        @for (cat of categories; track $index) {
          <button
            class="category-chip"
            [class.category-chip--active]="activeCategory === $index"
            (click)="onCategory($index)">
            {{ cat.label }}
            @if (cat.count !== null) {
              <span class="chip-count">{{ cat.count }}</span>
            } @else if ($index === 0) {
              <span class="chip-count">{{ collectionSize }}</span>
            }
          </button>
        }
        </div>
      </div>
    </div>
  </div>

  <section class="grid-section">
    <div class="grid-inner">
      <div class="grid-section-head">
        <h2 class="grid-section-title">รายการล่าสุด</h2>
        <a class="btn-ghost" [routerLink]="allPagesLink" [queryParams]="allPagesQueryParams">
          ดูทั้งหมด
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="2" y1="7" x2="11" y2="7"/><polyline points="7,3 11,7 7,11"/></svg>
        </a>
      </div>

      @if (isLoading) {
        <div class="skeleton-featured">
          <div class="skeleton-featured-media skeleton"></div>
          <div class="skeleton-featured-body">
            <div class="skeleton-featured-meta">
              <div class="skeleton-meta-text skeleton"></div>
              <div class="skeleton-meta-text-sm skeleton"></div>
              <div class="skeleton-meta-text-sm skeleton"></div>
            </div>
            <div class="skeleton-featured-title skeleton"></div>
            <div class="skeleton-featured-deck skeleton"></div>
            <div class="skeleton-featured-deck-2 skeleton"></div>
            <div class="skeleton-featured-topics">
              <div class="skeleton-topic skeleton"></div>
              <div class="skeleton-topic-2 skeleton"></div>
              <div class="skeleton-topic skeleton"></div>
            </div>
            <div class="skeleton-cta">
              <div class="skeleton-btn skeleton"></div>
              <div class="skeleton-ref skeleton"></div>
            </div>
          </div>
        </div>
        <div class="card-grid" style="margin-top: 32px;">
          @for (i of [1,2,3,4,5,6]; track i) {
            <div class="skeleton-card">
              <div class="skeleton-card-cover skeleton"></div>
              <div class="skeleton-card-body">
                <div class="skeleton-meta">
                  <div class="skeleton-meta-text skeleton"></div>
                  <div class="skeleton-meta-text-sm skeleton"></div>
                </div>
                <div class="skeleton-title skeleton"></div>
                <div class="skeleton-deck skeleton"></div>
                <div class="skeleton-deck-sm skeleton"></div>
                <div class="skeleton-footer">
                  <div class="skeleton-stat skeleton"></div>
                  <div class="skeleton-link skeleton"></div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else if (pages.length === 0) {
        <div class="grid-empty">
          <h3>ไม่พบรายการประชาสัมพันธ์</h3>
          <p>ลองเปลี่ยนคำค้นหา หรือกลับมาตรวจสอบใหม่อีกครั้ง</p>
        </div>
      } @else {
        <div class="card-grid">
          @for (item of gridCards; track item.id ?? $index) {
            <article class="card">
              <!-- Cover -->
              <a class="card-cover" [routerLink]="getPageLink(item)">
                @if (item.businessNames?.[0] || item.dataType) {
                  <span class="card-cat-chip">{{ item.businessNames?.[0] || item.dataType }}</span>
                }
                @if (item.coverPath) {
                  <img [src]="item.coverPath" [alt]="item.pageName || 'cover'" class="card-img">
                } @else {
                  <div class="card-placeholder"
                    [class.card-placeholder--green]="$index % 3 === 0"
                    [class.card-placeholder--gold]="$index % 3 === 1"
                    [class.card-placeholder--neutral]="$index % 3 === 2">
                    @if ($index % 3 === 0) {
                      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.25"><polygon points="32,8 40,26 60,26 44,38 50,56 32,44 14,56 20,38 4,26 24,26"/></svg>
                    } @else if ($index % 3 === 1) {
                      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.25"><rect x="12" y="20" width="40" height="32" rx="3"/><path d="M22 20v-6a10 10 0 0 1 20 0v6"/></svg>
                    } @else {
                      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.25"><path d="M32 8C21 8 12 17 12 28c0 16 20 28 20 28s20-12 20-28C52 17 43 8 32 8z"/><circle cx="32" cy="28" r="6"/></svg>
                    }
                  </div>
                }
              </a>

              <div class="card-body">
                @if (getCardCodes(item).length > 0 || item.pageCode) {
                  <div class="card-codes">
                    @for (code of getCardCodes(item); track code) {
                      <span class="card-code">{{ code }}</span>
                    }
                    @if (getExtraCodesCount(item) > 0) {
                      <span class="card-code card-code--more" [routerLink]="getPageLink(item)">+{{ getExtraCodesCount(item) }}</span>
                    }
                  </div>
                }
                <div class="card-meta">
                  <span class="card-org">{{ getFallbackSubtitle(item) }}</span>
                  <span class="card-sep">·</span>
                  <span class="card-date">{{ formatThaiDate(item.modifiedDate ?? item.createdDate) }}</span>
                </div>
                <h3 class="card-title">
                  <a [routerLink]="getPageLink(item)">{{ item.pageName || '-' }}</a>
                </h3>
<!--                <p class="card-deck">{{ item.productName || getFallbackSubtitle(item) }}</p>-->
                @if (getProductDetailPreview(item)) {
                  <p class="card-detail">{{ getProductDetailPreview(item) }}</p>
                }
                <div class="card-foot">
                  <div class="card-foot-stats">
                    <span class="card-views">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="6.5" cy="6.5" rx="5.5" ry="4"/><circle cx="6.5" cy="6.5" r="1.5" fill="currentColor" stroke="none"/></svg>
                      {{ (item.viewCount || 0) | number }}
                    </span>
                    <span class="card-rating">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor"><polygon points="6,1 7.5,4.5 11,4.8 8.5,7 9.3,10.5 6,8.5 2.7,10.5 3.5,7 1,4.8 4.5,4.5"/></svg>
                      {{ (item.averageScore || 0).toFixed(1) }}
                    </span>
                  </div>
                  <a class="card-readmore" [routerLink]="getPageLink(item)">
                    อ่านต่อ
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="2" y1="6.5" x2="11" y2="6.5"/><polyline points="7,3 11,6.5 7,10"/></svg>
                  </a>
                </div>
              </div>
            </article>
          }
        </div>
      }
    </div>
  </section>

  @if (collectionSize > pageSize) {
    <div class="pagination-bar">
      <div class="pagination-inner">
        <span class="pagination-info">
          แสดง {{ pageRangeStart }}–{{ pageRangeEnd }} จาก {{ collectionSize }} รายการ · หน้า {{ page }} / {{ totalPages }}
        </span>
        <div class="pagination-controls">
          <button class="page-btn" (click)="prevPage()" [disabled]="page === 1">‹</button>
          @for (p of paginationPages; track $index) {
            @if (p === '...') {
              <span class="page-ellipsis">···</span>
            } @else {
              <button class="page-btn" [class.page-btn--active]="page === p" (click)="goToPage(p)">{{ p }}</button>
            }
          }
          <button class="page-btn" (click)="nextPage()" [disabled]="page === totalPages">›</button>
        </div>
      </div>
    </div>
  }

</div>
